/**
 * Subimods Support Pages — shared FAQ search + accordion helpers
 * Expects root: [data-sm-support]
 * Docs: SM-SUPPORT-PAGES.md
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .replace(/[^\w\s+]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function initRoot(root) {
    if (!root || root.dataset.smSupportReady === 'true') return;
    root.dataset.smSupportReady = 'true';

    var input = root.querySelector('[data-sm-support-search]');
    var clearBtn = root.querySelector('[data-sm-support-clear]');
    var meta = root.querySelector('[data-sm-support-meta]');
    var empty = root.querySelector('[data-sm-support-empty]');
    var tags = root.querySelectorAll('[data-sm-support-tag]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sm-support-item]'));

    if (!items.length) return;

    function setMeta(text) {
      if (meta) meta.textContent = text || '';
    }

    function setClearVisible(visible) {
      if (!clearBtn) return;
      clearBtn.classList.toggle('is-visible', !!visible);
    }

    function filter(query, options) {
      options = options || {};
      var q = normalize(query);
      var matchCount = 0;
      var firstMatch = null;

      items.forEach(function (item) {
        var haystack = normalize(item.getAttribute('data-search') || item.textContent);
        var matches = !q || haystack.indexOf(q) !== -1;
        item.classList.toggle('is-hidden', !matches);
        item.classList.toggle('is-match', !!(q && matches));
        if (matches) {
          matchCount += 1;
          if (!firstMatch) firstMatch = item;
        }
      });

      if (empty) {
        empty.classList.toggle('is-visible', matchCount === 0);
      }

      if (!q) {
        setMeta('');
      } else if (matchCount === 0) {
        setMeta('No matching questions');
      } else {
        setMeta(matchCount + (matchCount === 1 ? ' question found' : ' questions found'));
      }

      setClearVisible(!!q);

      if (options.openFirst && firstMatch && matchCount === 1) {
        openAndFocus(firstMatch);
      }

      return { count: matchCount, firstMatch: firstMatch };
    }

    function openAndFocus(item) {
      if (!item) return;
      item.open = true;
      item.classList.remove('is-flash');
      void item.offsetWidth;
      item.classList.add('is-flash');
      var top = item.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: top, behavior: 'smooth' });
      var summary = item.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
    }

    function activateTag(tagEl) {
      tags.forEach(function (tag) {
        tag.classList.toggle('is-active', tag === tagEl);
      });
      var value = tagEl.getAttribute('data-sm-support-tag') || '';
      if (input) input.value = value;
      var result = filter(value);
      if (result.firstMatch) openAndFocus(result.firstMatch);
    }

    if (input) {
      input.addEventListener('input', function () {
        tags.forEach(function (tag) {
          tag.classList.remove('is-active');
        });
        filter(input.value);
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          var result = filter(input.value, { openFirst: true });
          if (result.count > 1 && result.firstMatch) {
            openAndFocus(result.firstMatch);
          }
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (input) input.value = '';
        tags.forEach(function (tag) {
          tag.classList.remove('is-active');
        });
        filter('');
        if (input) input.focus();
      });
    }

    tags.forEach(function (tag) {
      tag.addEventListener('click', function () {
        activateTag(tag);
      });
    });

    // Deep-link: /pages/faq-page#can-i-return-an-item
    if (window.location.hash) {
      var target = root.querySelector(window.location.hash);
      if (target && target.matches('[data-sm-support-item]')) {
        openAndFocus(target);
      }
    }

    filter(input ? input.value : '');
  }

  function initAll() {
    document.querySelectorAll('[data-sm-support]').forEach(initRoot);
  }

  ready(initAll);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-sm-support]');
    if (root) {
      root.dataset.smSupportReady = 'false';
      initRoot(root);
    }
  });
})();
